export function isInternalUrl(url: string) {
    return url.startsWith("/") && !url.startsWith("//");
}

export function getCustomerScopedPath(customerId: number, url: string) {
    const path = url.startsWith("/") ? url : `/${url}`;
    return `/${customerId}${path}`;
}

export function parseCustomerId(customerId: string) {
    const parsedCustomerId = Number(customerId);

    if (!Number.isInteger(parsedCustomerId) || parsedCustomerId <= 0) {
        return undefined;
    }

    return parsedCustomerId;
}
